import { useEffect, useRef } from "react";
import { SSEClient } from "../streaming/SSEClient";
import eventEmitter from "../utils/eventEmitter";
import { FLAGS } from "../utils/featureFlags";
import { SessionManager } from "../session/SessionManager";

export default function useSSEStreaming({ conversationId, tenantId, botId }) {
	const clientRef = useRef(null);

	useEffect(() => {
		if (!FLAGS.USE_SSE_STREAMING) return;
		if (!conversationId || !tenantId) return;

		clientRef.current?.destroy();

		const contactId = SessionManager.getSocketContactId();
		if (!contactId) return;
		const sessionId = SessionManager.getSessionId();

		clientRef.current = new SSEClient(conversationId, contactId, tenantId, sessionId, botId, {
			onChunk: ({ recordId, conversationId: convId, chunk }) => {
				eventEmitter.emit("record_update_stream", {
					recordId,
					conversationId: convId,
					chunk,
					done: false,
					_source: "sse",
				});
			},
			onDone: ({ recordId, conversationId: convId, fullMessage }) => {
				eventEmitter.emit("record_update_stream", {
					recordId,
					conversationId: convId,
					chunk: "",
					done: true,
					fullMessage,
					_source: "sse",
				});
			},
		});

		return () => {
			clientRef.current?.destroy();
			clientRef.current = null;
		};
	}, [conversationId, tenantId, botId]);
}
